import React, { useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import TabNavigation from '../../components/ui/TabNavigation';
import AudioPlayerBar from '../../components/ui/AudioPlayerBar';
import LiveBroadcastCard from './components/LiveBroadcastCard';
import BroadcastFeedCard from './components/BroadcastFeedCard';
import QuickAccessPanel from './components/QuickAccessPanel';
import SearchFilterBar from './components/SearchFilterBar';
import Icon from '../../components/AppIcon';

const MainDashboard = () => {
  const navigate = useNavigate();
  const [currentAudio, setCurrentAudio] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({ topic: 'all', language: 'all', type: 'all' });

  const liveBroadcasts = [
  {
    id: 1,
    title: "Философия присутствия: разговор о подлинности",
    description: "Глубокое погружение в концепцию аутентичного существования и медиа-присутствия в современном мире",
    hostName: "Александр Медведев",
    hostAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_127a46d03-1763294132672.png",
    hostAvatarAlt: "Professional headshot of middle-aged man with gray beard wearing casual black shirt in studio setting",
    artwork: "https://images.unsplash.com/photo-1675430428298-ecd1827c18fd",
    artworkAlt: "Vintage radio microphone in warm studio lighting with bokeh background creating intimate broadcasting atmosphere",
    listenerCount: 1247,
    duration: "1:23:45",
    category: "Философия"
  },
  {
    id: 2,
    title: "Звуки острова: медитативное путешествие",
    description: "Ambient-трансляция с Ко Пханган с живыми звуками природы и минималистичной музыкой",
    hostName: "Мария Соколова",
    hostAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_159d2c8f8-1763294679735.png",
    hostAvatarAlt: "Professional portrait of young woman with long brown hair in white blouse smiling warmly at camera",
    artwork: "https://images.unsplash.com/photo-1570028151193-2200ed465d46",
    artworkAlt: "Tropical island beach at sunset with palm trees silhouetted against orange and purple sky reflecting on calm water",
    listenerCount: 892,
    duration: "2:15:30",
    category: "Медитация"
  },
  {
    id: 3,
    title: "Голоса Silent Haven: истории сообщества",
    description: "Еженедельная передача где жители островного сообщества делятся своими историями и размышлениями",
    hostName: "Дмитрий Волков",
    hostAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_158b1a00f-1763293622509.png",
    hostAvatarAlt: "Casual portrait of bearded man in denim jacket with friendly expression outdoors in natural lighting",
    artwork: "https://img.rocket.new/generatedImages/rocket_gen_img_11de21461-1764805145609.png",
    artworkAlt: "Cozy community gathering space with wooden furniture warm lighting and people sitting in circle having conversation",
    listenerCount: 634,
    duration: "0:45:12",
    category: "Истории"
  }];


  const broadcastFeed = [
  {
    id: 4,
    title: "Архитектура влияния: как голос формирует реальность",
    description: "Исследование того, как аутентичное самовыражение через аудио создает новые формы социального влияния",
    hostName: "Александр Медведев",
    hostAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_127a46d03-1763294132672.png",
    hostAvatarAlt: "Professional headshot of middle-aged man with gray beard wearing casual black shirt in studio setting",
    artwork: "https://img.rocket.new/generatedImages/rocket_gen_img_16dbf2bb6-1764684926429.png",
    artworkAlt: "Abstract sound wave visualization with flowing blue and purple gradients representing audio frequencies and voice patterns",
    duration: "58:23",
    publishedAt: "2025-12-03T14:30:00",
    playCount: "2.3k",
    isNew: true
  },
  {
    id: 5,
    title: "Тишина между словами: искусство паузы",
    description: "Практическое руководство по использованию тишины как инструмента коммуникации и самопознания",
    hostName: "Елена Петрова",
    hostAvatar: "https://images.unsplash.com/photo-1688125289667-29353c89236b",
    hostAvatarAlt: "Serene portrait of woman with short blonde hair in meditation pose wearing light gray clothing against neutral background",
    artwork: "https://images.unsplash.com/photo-1695486825984-b2bfb9a751d9",
    artworkAlt: "Minimalist zen garden with smooth stones and rippled sand patterns creating peaceful meditative atmosphere in soft morning light",
    duration: "42:15",
    publishedAt: "2025-12-02T10:15:00",
    playCount: "1.8k",
    isNew: false
  },
  {
    id: 6,
    title: "Радиоволны сознания: технология и духовность",
    description: "Диалог о том, как современные технологии могут служить инструментом духовного развития",
    hostName: "Игорь Смирнов",
    hostAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19aaf6832-1764828715457.png",
    hostAvatarAlt: "Thoughtful portrait of man with glasses and short dark hair in navy sweater looking contemplatively to the side",
    artwork: "https://img.rocket.new/generatedImages/rocket_gen_img_1470b2657-1764669651426.png",
    artworkAlt: "Futuristic digital network visualization with glowing blue nodes and connections representing technology and consciousness intersection",
    duration: "1:12:45",
    publishedAt: "2025-12-01T18:00:00",
    playCount: "3.1k",
    isNew: false
  },
  {
    id: 7,
    title: "Музыка без границ: импровизация как философия",
    description: "Живая музыкальная сессия с размышлениями о спонтанности и творческой свободе",
    hostName: "Анна Кузнецова",
    hostAvatar: "https://images.unsplash.com/photo-1558918598-7858a88d0df2",
    hostAvatarAlt: "Artistic portrait of young woman with curly red hair playing acoustic guitar in dimly lit intimate performance space",
    artwork: "https://images.unsplash.com/photo-1705912681950-94f14910143d",
    artworkAlt: "Close-up of hands playing acoustic guitar with warm stage lighting and blurred musical instruments in background",
    duration: "1:35:20",
    publishedAt: "2025-11-30T20:30:00",
    playCount: "4.5k",
    isNew: false
  },
  {
    id: 8,
    title: "Голос как инструмент трансформации",
    description: "Практические техники работы с голосом для личностного роста и самовыражения",
    hostName: "Мария Соколова",
    hostAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_159d2c8f8-1763294679735.png",
    hostAvatarAlt: "Professional portrait of young woman with long brown hair in white blouse smiling warmly at camera",
    artwork: "https://img.rocket.new/generatedImages/rocket_gen_img_14142246e-1764709707951.png",
    artworkAlt: "Professional recording studio with vintage microphone in focus and sound dampening panels creating professional audio environment",
    duration: "52:10",
    publishedAt: "2025-11-29T16:45:00",
    playCount: "2.7k",
    isNew: false
  }];


  const userBroadcasts = [
  {
    id: 101,
    title: "Утренние размышления",
    listenerCount: 45
  },
  {
    id: 102,
    title: "Вечерний джаз",
    listenerCount: 128
  }];


  const notifications = [
  {
    id: 201,
    message: "Александр Медведев начал новый эфир",
    time: "5 мин. назад",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_127a46d03-1763294132672.png",
    avatarAlt: "Professional headshot of middle-aged man with gray beard wearing casual black shirt in studio setting"
  },
  {
    id: 202,
    message: "Новый подписчик на ваш канал",
    time: "1 ч. назад",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_140e66e9f-1763299767775.png",
    avatarAlt: "Friendly portrait of woman with shoulder-length brown hair in casual blue top smiling at camera"
  },
  {
    id: 203,
    message: "Мария Соколова упомянула вас в эфире",
    time: "3 ч. назад",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_159d2c8f8-1763294679735.png",
    avatarAlt: "Professional portrait of young woman with long brown hair in white blouse smiling warmly at camera"
  }];


  const suggestedChannels = [
  {
    id: 301,
    name: "Философия каждый день",
    subscriberCount: "12.5k",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1da385ba4-1763292591482.png",
    avatarAlt: "Intellectual portrait of older man with white hair and glasses in formal attire representing philosophy channel"
  },
  {
    id: 302,
    name: "Звуки природы",
    subscriberCount: "8.3k",
    avatar: "https://images.unsplash.com/photo-1594385697409-42465d75c90a",
    avatarAlt: "Peaceful portrait of woman with long blonde hair in natural outdoor setting representing nature sounds channel"
  },
  {
    id: 303,
    name: "Ночные истории",
    subscriberCount: "15.7k",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_181ead4c1-1764778197123.png",
    avatarAlt: "Mysterious portrait of man with dark hair in dim lighting representing storytelling channel atmosphere"
  }];


  const handleJoinBroadcast = (broadcast) => {
    setCurrentAudio({
      url: `https://example.com/audio/${broadcast?.id}.mp3`,
      title: broadcast?.title,
      artist: broadcast?.hostName,
      artwork: broadcast?.artwork
    });
  };

  const handlePlayBroadcast = (broadcast) => {
    setCurrentAudio({
      url: `https://example.com/audio/${broadcast?.id}.mp3`,
      title: broadcast?.title,
      artist: broadcast?.hostName,
      artwork: broadcast?.artwork
    });
  };

  const handleSaveBroadcast = (broadcast) => {
    console.log('Сохранено:', broadcast?.title);
  };

  const handleShareBroadcast = (broadcast) => {
    console.log('Поделиться:', broadcast?.title);
  };

  const handleCreateBroadcast = () => {
    navigate('/live-broadcasting-studio');
  };

  const handleViewChannel = (channel) => {
    navigate('/channel-profile');
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleAudioNext = () => {
    console.log('Следующий трек');
  };

  const handleAudioPrevious = () => {
    console.log('Предыдущий трек');
  };

  const handleAudioPlayPause = () => {
    console.log('Play/Pause toggled');
  };

  const handleAudioSeek = (time) => {
    console.log('Seek to:', time);
  };

  const handleAudioVolumeChange = (volume) => {
    console.log('Volume changed to:', volume);
  };

  return (
    <>
      <Helmet>
        <title>Главная | radio.co.im - Платформа аутентичного голоса</title>
        <meta name="description" content="radio.co.im - философский портал, где голос становится существованием. Слушайте живые эфиры, персонализированные рекомендации и общайтесь с единомышленниками." />
        <meta property="og:title" content="radio.co.im - Частота присутствия" />
        <meta property="og:description" content="Философский радио-портал для аутентичного самовыражения" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://radio.co.im" />
      </Helmet>
      
      <div className="main-dashboard min-h-screen bg-background">
        <TabNavigation />
        <div className="dashboard-container max-w-7xl mx-auto px-4 sm:px-6 py-6 lg:pr-80">
          <div className="dashboard-header mb-8">
            <div className="flex items-center justify-between mb-2">
              <h1 className="text-3xl font-heading font-semibold text-foreground">
                Главная
              </h1>
              <button
                onClick={handleCreateBroadcast}
                className="flex items-center gap-2 px-4 py-2.5 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-all duration-200 active:scale-95">

                <Icon name="Radio" size={20} color="currentColor" />
                <span className="hidden sm:inline font-heading font-medium">Начать эфир</span>
              </button>
            </div>
            <p className="text-muted-foreground">
              Откройте для себя аутентичные голоса и присоединяйтесь к живым эфирам
            </p>
          </div>

          <SearchFilterBar
            onSearch={handleSearch}
            onFilterChange={handleFilterChange} />


          <div className="live-section mb-12">
            <div className="section-header flex items-center gap-3 mb-6">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-error rounded-full animate-pulse" />
                <h2 className="text-2xl font-heading font-semibold text-foreground">
                  В эфире сейчас
                </h2>
              </div>
              <span className="text-sm text-muted-foreground">
                {liveBroadcasts?.length} активных трансляций
              </span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {liveBroadcasts?.map((broadcast) =>
              <LiveBroadcastCard
                key={broadcast?.id}
                broadcast={broadcast}
                onJoin={handleJoinBroadcast}
                onSave={handleSaveBroadcast} />

              )}
            </div>
          </div>

          <div className="feed-section">
            <div className="section-header mb-6">
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-2">
                Рекомендуемые эфиры
              </h2>
              <p className="text-sm text-muted-foreground">
                Подобрано на основе ваших интересов и истории прослушиваний
              </p>
            </div>

            <div className="space-y-4">
              {broadcastFeed?.map((broadcast) =>
              <BroadcastFeedCard
                key={broadcast?.id}
                broadcast={broadcast}
                onPlay={handlePlayBroadcast}
                onSave={handleSaveBroadcast}
                onShare={handleShareBroadcast} />

              )}
            </div>
          </div>
        </div>
        <div className="hidden lg:block fixed right-0 top-16 bottom-0 w-80 overflow-y-auto">
          <div className="p-6">
            <QuickAccessPanel
              userBroadcasts={userBroadcasts}
              notifications={notifications}
              suggestedChannels={suggestedChannels}
              onCreateBroadcast={handleCreateBroadcast}
              onViewChannel={handleViewChannel} />

          </div>
        </div>
        <AudioPlayerBar
          audioSource={currentAudio}
          initialPlaybackState="paused"
          onNext={handleAudioNext}
          onPrevious={handleAudioPrevious}
          onPlayPause={handleAudioPlayPause}
          onSeek={handleAudioSeek}
          onVolumeChange={handleAudioVolumeChange} />

      </div>
    </>
  );
};

export default MainDashboard;